import { useState } from "react";
import { apiClient } from "../../utils/api";
import {
  EmailVerificationRequest,
  EmailVerificationResponse,
} from "../../types/auth";

const useEmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiVerificationError, setApiVerificationError] = useState("");
  const [authcode, setAuthcode] = useState<string | null>(null);

  const verifyEmail = async (data: EmailVerificationRequest) => {
    setIsLoading(true);
    setApiVerificationError("");
    setAuthcode(null);

    try {
      const response = await apiClient.post<EmailVerificationResponse>(
        "/api/v1/auth/email/verification",
        data
      );
      const responseData = response.data;
      
      console.log("이메일 인증 API 응답:", responseData);

      // 중복 체크 - duplicate가 명시적으로 true인 경우만
      if (responseData.duplicate === true) {
        return { duplicate: true };
      }

      if (responseData.status) {
        console.log("authcode 설정:", responseData.authcode);
        if (responseData.authcode) {
          setAuthcode(responseData.authcode);
        } else {
          console.warn("API 응답에 authcode가 없습니다:", responseData);
          setApiVerificationError("인증 코드를 받지 못했습니다. 다시 시도해주세요.");
          throw new Error("authcode가 없음");
        }
        return { duplicate: false };
      } else {
        setApiVerificationError("이메일 인증에 실패했습니다. 다시 시도해주세요.");
        throw new Error("이메일 인증 실패");
      }
    } catch (err: any) {
      console.error("이메일 인증 오류:", err);
      if (err.response?.data?.error) {
        setApiVerificationError(err.response.data.error);
      } else {
        setApiVerificationError("이메일 인증에 실패했습니다. 다시 시도해주세요.");
      }
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    apiVerificationError,
    setApiVerificationError,
    authcode,
    verifyEmail,
  };
};

export default useEmailVerification;
